import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext, useState, useEffect } from 'react';
import { Button, Form, Toast } from 'react-bootstrap';
import { Context } from '../..';
import UserService from '../../services/UserService';
// import { DiseaseModal } from './modal/DiseaseModal';
import { OrganizationModal } from './modal/OrganizationModal';
import { SpecializationModal } from './modal/SpecializationModal';
import InputMask from "react-input-mask";
import { municipality } from '../types/municipalityTypes';
import AuthService from '../../services/AuthService';
import DocumentsService from '../../services/DocumentsService';


const Config: FC = () => {
    const { store } = useContext(Context);
    const [showToast, setShowToast] = useState(false);
    const [toastInfo, setToastInfo] = useState('');
    const [new_password, setNewPassword] = useState('');
    const [current_password, setCurrentPassword] = useState('');
    const [passwordForm, setPasswordForm] = useState(false);
    const [see, setSee] = useState(false);
    const [nosologies, setNosologies] = useState<[]>([]);

    const getNosologies = async () => {
        const res = await DocumentsService.getNosologies();
        setNosologies(res.data.results);
    };

    useEffect(() => {
        getNosologies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (document.getElementById('currentPassword') as HTMLInputElement) {
        if (see) {
            (document.getElementById('currentPassword') as HTMLInputElement).type = 'text'
        } else {
            (document.getElementById('currentPassword') as HTMLInputElement).type = 'password'
        }
    }

    if (document.getElementById('newPassword') as HTMLInputElement) {
        if (see) {
            (document.getElementById('newPassword') as HTMLInputElement).type = 'text'
        } else {
            (document.getElementById('newPassword') as HTMLInputElement).type = 'password'
        }
    }


    const onChangeSpec = (e: React.ChangeEvent<any>) => {
        if (e.target.name === 'phone') {
            // eslint-disable-next-line no-useless-escape
            store.setSpecInfo({ ...store.specInfo, [e.target.name]: e.target.value.replace(/[(\)\-]+/g, '') })
        } else if (e.target.name === 'snils') {
            store.setSpecInfo({ ...store.specInfo, [e.target.name]: e.target.value.replace(/[-\s]+/g, '') })
        } else {
            store.setSpecInfo({ ...store.specInfo, [e.target.name]: e.target.value })
        }

    };

    const onChangeUser = (e: React.ChangeEvent<any>) => {
        if (e.target.name === 'phone') {
            // eslint-disable-next-line no-useless-escape
            store.setUserInfo({ ...store.userInfo, [e.target.name]: e.target.value.replace(/[(\)\-]+/g, '') })
        } else if (e.target.name === 'snils') {
            store.setUserInfo({ ...store.userInfo, [e.target.name]: e.target.value.replace(/[-\s]+/g, '') })
        } else {
            store.setUserInfo({ ...store.userInfo, [e.target.name]: e.target.value })
        }
    };

    const updateSpecInfo = async () => {
        if (store.specInfo?.id) {

            if (store.specInfo.fio && store.specInfo.organizations.length && store.specInfo.phone && store.specInfo.snils && store.specInfo.specializations.length) {

                try {
                    await UserService.updateSpecInfo(store.specInfo.id, store.specInfo);
                    setToastInfo(store.lang === 'ba' ? 'Һеҙҙең мәғлүмәттәрегеҙ һаҡланды' : store.lang === 'ru' ? 'Ваши настройки сохранены' : 'Your settings are saved');
                    setShowToast(true);
                    // alert('Your settings are saved')
                } catch (e) {
                    console.log(e);
                };

            } else {
                setToastInfo(store.lang === 'ba' ? 'Бөтә баҫыуҙар ҙа тултырылырға тейеш' : store.lang === 'ru' ? 'Все поля должны быть заполнены' : 'All fields must be filled in');
                setShowToast(true);
                // alert('All fields must be filled in')
            }

        } else {

            if (store.specInfo.fio && store.specInfo.organizations.length && store.specInfo.phone && store.specInfo.snils && store.specInfo.specializations.length) {

                try {
                    await UserService.createSpecInfo(store.specInfo);
                    setToastInfo(store.lang === 'ba' ? 'Һеҙҙең мәғлүмәттәрегеҙ һаҡланды' : store.lang === 'ru' ? 'Ваши настройки сохранены' : 'Your settings are saved');
                    setShowToast(true);
                } catch (e) {
                    console.log(e);
                };

            } else {
                setToastInfo(store.lang === 'ba' ? 'Бөтә баҫыуҙар ҙа тултырылырға тейеш' : store.lang === 'ru' ? 'Все поля должны быть заполнены' : 'All fields must be filled in');
                setShowToast(true);
            }

        };
    };

    const updateUserInfo = async () => {
        if (store.userInfo?.id) {

            if (store.userInfo.gender && store.userInfo.birth_date && store.userInfo.diseases && store.userInfo.fio && store.userInfo.phone && store.userInfo.school_class && store.userInfo.snils) {
                try {
                    await UserService.updateUserInfo(store.userInfo.id, store.userInfo);
                    setToastInfo(store.lang === 'ba' ? 'Һеҙҙең мәғлүмәттәрегеҙ һаҡланды' : store.lang === 'ru' ? 'Ваши настройки сохранены' : 'Your settings are saved');
                    setShowToast(true);
                } catch (e) {
                    console.log(e);
                };

            } else {
                setToastInfo(store.lang === 'ba' ? 'Бөтә баҫыуҙар ҙа тултырылырға тейеш' : store.lang === 'ru' ? 'Все поля должны быть заполнены' : 'All fields must be filled in');
                setShowToast(true);
            }

        } else {

            if (store.userInfo.gender && store.userInfo.birth_date && store.userInfo.diseases && store.userInfo.fio && store.userInfo.phone && store.userInfo.school_class && store.userInfo.snils) {
                try {
                    await UserService.createUserInfo(store.userInfo);
                    setToastInfo(store.lang === 'ba' ? 'Һеҙҙең мәғлүмәттәрегеҙ һаҡланды' : store.lang === 'ru' ? 'Ваши настройки сохранены' : 'Your settings are saved');
                    setShowToast(true);
                } catch (e) {
                    console.log(e);
                };

            } else {
                setToastInfo(store.lang === 'ba' ? 'Бөтә баҫыуҙар ҙа тултырылырға тейеш' : store.lang === 'ru' ? 'Все поля должны быть заполнены' : 'All fields must be filled in');
                setShowToast(true);
            }

        };
    };

    const setPassword = async () => {
        try {
            await AuthService.setNewPass({ current_password, new_password, re_new_password: new_password });
            setPasswordForm(false);
            alert(store.lang === 'ba' ? 'Аккаунтығыҙҙың пароле үҙгәрҙе.' : store.lang === 'ru' ? 'Пароль Вашего аккаунта изменен.' : 'Your account password has been changed.')
        } catch (e) {
            console.log(e);
            alert(store.lang === 'ba' ? 'Хата' : store.lang === 'ru' ? 'Ошибка' : 'Error')
        }
    }

    return (store.user.is_active ?
        (store.user.is_staff ?
            <Form className='row m-5'>

                <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label><Trans>Your email</Trans>: <strong>{store.user?.email}</strong></Form.Label>
                    <span style={{ float: 'right' }}><button type='button' className='btn btn-primary' onClick={() => setPasswordForm(!passwordForm)}><Trans>Change the password</Trans></button></span>
                </Form.Group>

                {passwordForm ? <>
                    <Form.Group className="col-md-5 mb-3" controlId="formCurrentPassword">
                        <div className="row align-items-end h-100">
                            <label className="form-label"><Trans>Current password</Trans></label>
                            <div className="col d-flex">
                                <input
                                    id='currentPassword'
                                    className="form-control"
                                    onChange={e => setCurrentPassword(e.target.value)}
                                />
                                <div style={{ position: 'relative' }}><i className={'icon' + (see ? ' see' : ' unsee') + ' absolute'} onClick={() => setSee(!see)} /></div>
                            </div>
                        </div>
                    </Form.Group>

                    <Form.Group className="col-md-5 mb-3" controlId="formNewPassword">
                        <div className="row align-items-end h-100">
                        <label className="form-label"><Trans>New password</Trans></label>
                            <div className="col d-flex">
                                <input
                                    id='newPassword'
                                    className="form-control"
                                    onChange={e => setNewPassword(e.target.value)}
                                />
                                <div style={{ position: 'relative' }}><i className={'icon' + (see ? ' see' : ' unsee') + ' absolute'} onClick={() => setSee(!see)} /></div>
                            </div>
                        </div>
                    </Form.Group>

                    <Form.Group className="col-md-2 mb-3" controlId="formPasswordButton">
                        <div className="row align-items-end h-100">
                            <div className="col">
                                <button type='button' className='btn btn-primary' onClick={() => setPassword()}><Trans>Save the password</Trans></button>
                            </div>
                        </div>
                    </Form.Group></>
                    : null}

                <Form.Group className="col-md-12 mb-3" controlId="formName">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your full name</Trans></Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={store.lang === 'ba' ? 'Тулы исемегеҙҙе индерегеҙ' : store.lang === 'ru' ? 'Введите полное имя' : 'Enter the full name'}
                                defaultValue={store.specInfo?.fio}
                                name='fio'
                                onChange={(e: React.ChangeEvent<any>) => onChangeSpec(e)} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formSnils">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your insurance number of an individual personal account (СНИЛС)</Trans></Form.Label>
                            <InputMask
                                mask="999-999-999 99"
                                name='snils'
                                className='form-control'
                                placeholder={store.lang === 'ba' ? 'Шәхси иҫәптең страховка номерын индерегеҙ (СНИЛС)' : store.lang === 'ru' ? 'Введите страховой номер индивидуального лицевого счета (СНИЛС)' : 'Enter the insurance number of an individual personal account (СНИЛС)'}
                                onChange={(e: React.ChangeEvent<any>) => onChangeSpec(e)}
                                defaultValue={store.specInfo?.snils} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formPhone">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your phone number</Trans></Form.Label>
                            <InputMask
                                mask="+7(999)999-99-99"
                                name='phone'
                                className='form-control'
                                placeholder={store.lang === 'ba' ? 'Телефон номерығыҙҙы индерегеҙ' : store.lang === 'ru' ? 'Введите свой номер телефона' : 'Enter your phone number'}
                                onChange={(e: React.ChangeEvent<any>) => onChangeSpec(e)}
                                defaultValue={store.specInfo?.phone} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Select a specialty</Trans></Form.Label>
                            <SpecializationModal />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formMunicipality">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>District/City</Trans></Form.Label>
                            <select
                                className='form-control'
                                placeholder={store.lang === 'ba' ? 'Муниципалитет исемен индерегеҙ' : store.lang === 'ru' ? 'Введите название муниципалитета' : 'Enter the name of the municipality'}
                                defaultValue={store.specInfo?.municipality}
                                name='municipality'
                                onChange={(e: React.ChangeEvent<any>) => onChangeSpec(e)}
                            >
                                {municipality.map(item => {
                                    return <option value={item}>{item}</option>
                                })}
                            </select>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-12 mb-3">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Select an organization</Trans></Form.Label>
                            <OrganizationModal />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                    <Button variant="primary" type="button" onClick={() => updateSpecInfo()}>
                        <Trans>Save</Trans>
                    </Button>
                </Form.Group>

                <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                    <Toast.Header className='bg-success m-0 text-light'>
                        <strong className="me-auto"><Trans>Information</Trans></strong>
                    </Toast.Header>
                    <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
                </Toast>

            </Form >
            :
            <Form className='row m-5'>

                <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label><Trans>Your email</Trans>: <strong>{store.user?.email}</strong></Form.Label>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formName">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your full name</Trans></Form.Label>
                            <Form.Control
                                type="text"
                                placeholder={store.lang === 'ba' ? 'Тулы исемегеҙҙе индерегеҙ' : store.lang === 'ru' ? 'Введите полное имя' : 'Enter the full name'}
                                defaultValue={store.userInfo?.fio}
                                name='fio'
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formSnils">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your insurance number of an individual personal account (СНИЛС)</Trans></Form.Label>
                            <InputMask
                                mask="999-999-999 99"
                                name='snils'
                                className='form-control'
                                placeholder={store.lang === 'ba' ? 'Шәхси иҫәптең страховка номерын индерегеҙ (СНИЛС)' : store.lang === 'ru' ? 'Введите страховой номер индивидуального лицевого счета (СНИЛС)' : 'Enter the insurance number of an individual personal account (СНИЛС)'}
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)}
                                defaultValue={store.userInfo?.snils} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-4 mb-3" controlId="formPhone">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your phone number</Trans></Form.Label>
                            <InputMask
                                mask="+7(999)999-99-99"
                                name='phone'
                                className='form-control'
                                placeholder={store.lang === 'ba' ? 'Телефон номерығыҙҙы индерегеҙ' : store.lang === 'ru' ? 'Введите свой номер телефона' : 'Enter your phone number'}
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)}
                                defaultValue={store.userInfo?.phone} />
                        </div>
                    </div>

                </Form.Group>

                <Form.Group className="col-md-4 mb-3" controlId="formBirth">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your child's date of birth</Trans></Form.Label>
                            <Form.Control
                                type="date"
                                defaultValue={store.userInfo?.birth_date}
                                name='birth_date'
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)} />
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-4 mb-3" controlId="formBirth">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>Your child's gender</Trans></Form.Label>
                            <select
                                className='form-control'
                                defaultValue={store.userInfo?.gender}
                                name='gender'
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)}
                            >
                                <option value="" disabled selected>{store.lang === 'ba' ? 'Балағыҙҙың енесен һайлағыҙ' : store.lang === 'ru' ? 'Выберите пол вашего ребенка' : 'Select the gender of your child'}</option>
                                <option value="муж">муж</option>
                                <option value="жен">жен</option>

                            </select>
                        </div>
                    </div>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>The category of your child with disabilities</Trans></Form.Label>
                            <select
                                className='form-control'
                                defaultValue={store.userInfo?.diseases}
                                name='diseases'
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)}
                            >
                                <option value="" disabled selected>{store.lang === 'ba' ? 'Балағыҙҙың һаулыҡ мөмкинлектәре сикле категорияһын һайлағыҙ' : store.lang === 'ru' ? 'Выберите категорию Вашего ребенка с ОВЗ' : 'Select the category of your child with disabilities'}</option>
                                {nosologies.map(nos => {
                                    return <option key={nos['id']} value={nos['nosology']}>{nos['nosology']}</option>
                                })}
                            </select>
                        </div>
                    </div>
                    {/* <DiseaseModal /> */}
                </Form.Group>

                <Form.Group className="col-md-6 mb-3" controlId="formClass">
                    <div className="row align-items-end h-100">
                        <div className="col">
                            <Form.Label><Trans>What grade does your child study in?</Trans></Form.Label>
                            <select
                                className='form-control'
                                defaultValue={store.userInfo?.school_class}
                                name='school_class'
                                onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)}
                            >
                                <option value="" disabled selected>{store.lang === 'ba' ? 'Класты һайлағыҙ' : store.lang === 'ru' ? 'Выберите класс' : 'Select the class'}</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                                <option value="11">11</option>
                                <option value="12">12</option>
                                <option value="Специальная индивидуальная программа развития (СИПР)">Специальная индивидуальная программа развития (СИПР)</option>
                            </select>
                        </div>
                    </div>
                    {/* <Form.Control
                        type="text"
                        placeholder={store.lang === 'ba' ? 'Мәктәп класын индерегеҙ' : store.lang === 'ru' ? 'Введите школьный класс' : 'Enter the school class'}
                        defaultValue={store.userInfo?.school_class}
                        name='school_class'
                        onChange={(e: React.ChangeEvent<any>) => onChangeUser(e)} /> */}
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                    <Button variant="primary" type="button" onClick={() => updateUserInfo()}>
                        <Trans>Save</Trans>
                    </Button>
                </Form.Group>

                <Toast className='toast p-0 border-success' bg='light' onClose={() => setShowToast(false)} show={showToast} delay={5000} autohide>
                    <Toast.Header className='bg-success m-0 text-light'>
                        <strong className="me-auto"><Trans>Information</Trans></strong>
                    </Toast.Header>
                    <Toast.Body><strong>{toastInfo}</strong></Toast.Body>
                </Toast>

            </Form>
        )
        :
        <div className='m-5 text-center'><Trans>Please activate your account</Trans></div>
    )
};
export default observer(Config);